import { defineComponent as _defineComponent } from 'vue'
import BCXSuggestionBox from '@/components/molecules/BCXSuggestionBox.vue';
import { PropType, ref } from 'vue';
import BCXUserListItem from '@/components/molecules/BCXUserListItem.vue';
import { Contract } from '@/models/Contracts';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesActionContractSelector',
  props: {
  contracts: {
    type: Array as PropType<Contract[]>,
    default: () => []
  }
},
  emits: ['select'],
  setup(__props, { emit }) {





const searchTerm = ref('');

const onSelect = (item:any) => {
  emit('select', item);
};


return { __sfc: true,emit, searchTerm, onSelect, BCXSuggestionBox, BCXUserListItem }
}

})